import { VolunteerSearchResult } from "@/api";

export function formatVolunteerListName(volunteer: VolunteerSearchResult): string {
  return volunteer.firstName ? `${volunteer.lastName}, ${volunteer.firstName}` : volunteer.lastName;
}
